import { FIVE_MINUTES } from '@air/utilities';

export { FIVE_SECONDS as WORKSPACE_AGENT_REST_POLL_INITIAL_MS } from '@air/utilities';

export const WORKSPACE_AGENT_REST_POLL_MAX_MS = FIVE_MINUTES;

export const getNextWorkspaceAgentRestPollDelay = (currentDelayMs: number): number =>
  Math.min(currentDelayMs * 2, WORKSPACE_AGENT_REST_POLL_MAX_MS);
